export default __webpack_public_path__ + "static/media/en_espera_banco.04a869ab.png";